/** @jsxImportSource @emotion/react */

import { FC, ReactNode, useMemo } from "react";
import Typography from "../../../../Typography";
import { useUIStore } from "../../../../../hooks/useUIStore";
import HR from "../../../../HorizontalLine";
import { ColorNames } from "../../../../../theme";

interface TableRowProps {
  row: {
    label: string;
    value: string | ReactNode;
  };
  tableHead?: boolean;
  hideLabels?: boolean;
  hideValues?: boolean;
}

const styles = {
  row: {
    marginTop: 8,
    "&:first-of-type > p": {
      height: 30,
    },
  },
};

export const TableRow: FC<TableRowProps> = ({
  row,
  tableHead,
  hideLabels,
  hideValues,
}) => {
  const { documentColor } = useUIStore();

  const labelColor = useMemo(() => {
    if (tableHead) return documentColor;
    if (hideValues) return ColorNames.BLACK;
    return ColorNames.GREY;
  }, [tableHead, hideValues, documentColor]);

  return (
    <div css={styles.row}>
      {!hideLabels && (
        <Typography
          variant={hideValues ? "textMedium" : "textSmall"}
          component="p"
          color={labelColor}
          uppercase={tableHead}
          weight={tableHead ? "bold" : "regular"}
          align={hideValues ? "left" : "center"}
        >
          {row.label}
        </Typography>
      )}
      {!hideValues && (
        <Typography variant="textMedium" component="p">
          {row.value}
        </Typography>
      )}
      {tableHead && (
        <HR
          color={documentColor as unknown as ColorNames}
          dashedLine
          spacingSize="small"
        />
      )}
    </div>
  );
};

export default TableRow;
